
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 66.25 66.25"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.45 34.59a7.46 7.46 0 107.46 7.45c0-.48-.4-2.83-.4-3.31a7.46 7.46 0 017.45-7.46c.5 0 2.84.39 3.33.39a7.45 7.45 0 10-7.45-7.45c0 .49.39 2.84.39 3.33a7.46 7.46 0 01-7.45 7.45c-.49 0-2.85-.4-3.33-.4z","fill":"#7ac143"}}),_c('path',{attrs:{"d":"M40.97 34.59a7.46 7.46 0 107.45 7.45c0-.48-.4-2.83-.4-3.31a7.46 7.46 0 017.46-7.46c.49 0 2.83.39 3.32.39a7.45 7.45 0 10-7.45-7.45c0 .49.39 2.84.39 3.33a7.46 7.46 0 01-7.45 7.45c-.48 0-2.84-.4-3.32-.4z","fill":"#00a9e9"}}),_c('path',{attrs:{"d":"M34.64 58.82a7.46 7.46 0 107.45-7.45c-.49 0-2.83.4-3.32.39a7.44 7.44 0 01-7.45-7.45c0-.49.39-2.83.39-3.32a7.45 7.45 0 10-7.45 7.45c.48 0 2.84-.4 3.32-.39a7.45 7.45 0 017.46 7.45c-.06.46-.4 2.82-.4 3.32zM34.64 25.29a7.46 7.46 0 107.4-7.47c-.49 0-2.83.39-3.32.39a7.45 7.45 0 01-7.45-7.39c0-.49.39-2.83.39-3.32a7.45 7.45 0 10-7.45 7.44c.48 0 2.84-.39 3.32-.39A7.46 7.46 0 0134.99 22c-.01.45-.35 2.82-.35 3.29z","fill":"#7ac143"}})])
          )
        }
      }
    